var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "15px",
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-98.000000, -4161.000000)",
    fill: "#F5AD0D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 4018.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.8549833,51.166352 C84.5261263,50.6066826 77.8852952,39.4210409 77.3171665,38.4662455 C76.9438949,37.8394305 76.0544692,37.8497606 75.6808197,38.4662455 C75.2642676,39.1535654 68.5896057,50.3818187 68.125804,51.1949442 C67.7857962,51.7904001 68.1613357,52.5714286 68.9350945,52.5714286 L84.0409679,52.5714286 C84.7434743,52.5714286 85.2658655,51.8647398 84.8549833,51.166352 Z M76.5,51.3571429 C75.9971036,51.3571429 75.5892857,50.9495071 75.5892857,50.4464286 C75.5892857,49.94335 75.9971036,49.5357143 76.5,49.5357143 C77.0030786,49.5357143 77.4107143,49.94335 77.4107143,50.4464286 C77.4107143,50.9495071 77.0030786,51.3571429 76.5,51.3571429 Z M77.1071429,48.3533835 C77.1071429,48.7368421 76.9047619,48.9285714 76.5,48.9285714 C76.0952381,48.9285714 75.8928571,48.7368421 75.8928571,48.3533835 L75.2857143,42.7932331 C75.2857143,42.2180451 75.6904762,41.6428571 76.5,41.6428571 C77.3095238,41.6428571 77.7142857,42.2180451 77.7142857,42.7932331 L77.1071429,48.3533835 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d6c65360cce6214accf418cdef772a10.svg";
export { ForwardRef as ReactComponent };